<template lang="pug">
  transition(name='modal')
    div(class="c-modal", @click.self="$emit('hide')")
      div(class="c-modal__content", :style="{width: width}", :class='modalClass')
        div(class='u-right-align')
          button(class='u-fz-h3 u-color-quaternary u-mb2' @click="$emit('hide')")
            i(class='u-icon') close
        slot(name='content')
</template>

<script>
  export default {
    props: {
      width: {
        type: String,
        default: 'auto'
      },
      modalClass: String
    },

    beforeCreate () {
      window.$('body').css('overflow-y', 'hidden')
    },

    beforeDestroy () {
      window.$('body').css('overflow-y', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Modal.vue